import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const EditIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Stockholm-icons / General / Edit">
        <path
          id="Path 11"
          d="M20.4745 8.33286C21.0488 8.90716 21.0617 9.83422 20.5036 10.4243L10.9438 20.5312C10.6605 20.8307 10.2664 21.0005 9.85405 21.0005L5.49995 21.0005C4.67153 21.0005 3.99995 20.3289 3.99995 19.5005L3.99995 15.1079C3.99995 14.7183 4.15155 14.344 4.42266 14.0642L14.0817 4.09491C14.6646 3.49328 15.6273 3.48567 16.2196 4.07802L20.4745 8.33286Z"
          {...svgAttrs}
        />
      </g>
    </svg>
  );
};

export default EditIcon;
